<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ziyuanguanli`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_6478fcbd69__clip0_1284_244533)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.02637L16.125 4.79843V13.2015L9 16.9736L1.875 13.2015V4.79843L9 1.02637ZM3.375 6.49567V12.2984L8.25 14.8793V9.07655L3.375 6.49567ZM9.75 9.07655V14.8793L14.625 12.2984V6.49567L9.75 9.07655ZM13.7721 5.24999L9 2.72361L4.22795 5.24999L9 7.77637L13.7721 5.24999Z"/></g><defs><clipPath id="svg_6478fcbd69__clip0_1284_244533"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconZiyuanguanli',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
